module.exports = __webpack_public_path__ + "static/img/v72.e77105c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v72.png
// module id = Uk0Y
// module chunks = 1